require('./boolean.html');
require('./checkbox.html');
require('./contextmenu_field.html');
require('./contextmenu_field_in_media_accordion_element.html');
require('./contextmenu_form.html');
require('./contextmenu_group.html');
require('./contextmenu_media_accordion_element.html');
require('./contextmenu_row.html');
require('./contextmenu_section.html');
require('./date.html');
require('./default_field.html');
require('./download.html');
require('./dropdown_multiple_select.html');
require('./dropdown_single_select.html');
require('./dropdown_single_select_ajax.html');
require('./euro_betrag.html');
require('./file.html');
require('./h1.html');
require('./h2.html');
require('./hintbox.html');
require('./image.html');
require('./kfz_kennzeichen.html');
require('./multiple_file.html');
require('./placeholder.html');
require('./radio_buttons.html');
require('./single_checkbox.html');
require('./string.html');
require('./string_ajax_autocomplete.html');
require('./submitted_with_npa_info.html');
require('./text.html');
require('./textarea.html');
require('./time.html');
require('./two_list_select.html');
require('./video.html');
